module.exports = __webpack_public_path__ + "static/media/3219A3_5_0.5b6c6c04.woff2";